import React from "react";
import PropTypes from "prop-types";
import { injectIntl, FormattedMessage } from "react-intl";
import MenuElement from "./menu-element";
import { useAuthDataContext, RestrictedToScopedView } from "components/auth";
import { useCurrentCustomerContext } from "../../../../current-customer-context";

const MenuEntries = ({ currentClient }) => {
  const { onLogout } = useAuthDataContext();
  const { customers } = useCurrentCustomerContext();

  return (
    <>
      <RestrictedToScopedView>
        {customers?.length > 1 ? (
          <MenuElement url="/customer/change">
            <FormattedMessage id="app.menu.customer.change" /> ({currentClient})
          </MenuElement>
        ) : null}
      </RestrictedToScopedView>
      <MenuElement url="/user/profile">
        <FormattedMessage id="app.menu.user" />
      </MenuElement>
      <MenuElement onClick={onLogout}>
        <FormattedMessage id="app.menu.logout" />
      </MenuElement>
    </>
  );
};

MenuEntries.propTypes = {
  /**
   * Indica si el menú está abierto
   */
  anchorEl: PropTypes.object,
  /**
   * Indica si el menú está abierto
   */
  open: PropTypes.bool,
  /**
   * Cliente actual
   */
  currentClient: PropTypes.string,
  /**
   * Callback que se ejecuta al cerrar el menú
   */
  onClose: PropTypes.func,
};

export default injectIntl(MenuEntries);
